// Our story: crack-the-can flavor roulette and the struck-through "no more" list. (The scroll-lit manifesto came off
// 2026-10-12, Bella: "Our Story: Remove Manifesto".)
import { $, reducedMotion, initChrome, initReveal } from 'v2/ui.js';
import { ASSET_V, FLAVORS, productUrl } from 'v2/catalog.js';
import { asset } from 'v2/asset.js';

initChrome();

/* ---------- The founders: Matthew, Jeff and Joey for everyone; the five with the code ---------- */
// /founders/story.html (all five, embargoed) is served only to visitors who unlocked with the code (middleware.js);
// everyone else keeps the three baked into the page. A link to /story#founders lands on the section.
const founders = $('[data-story-founders]');
if (founders) {
  Promise.resolve({ status: 204 }) // Shopify: the founders section arrives with the announcement
    .then((r) => (r.status === 200 ? r.text() : null)) // 204 without the code
    .then((html) => {
      if (!html) return;
      founders.innerHTML = html;
      initReveal(founders);
      if (location.hash === '#founders') founders.scrollIntoView();
    })
    .catch(() => {});
}

/* ---------- Crack the can: every one you open is the next flavor ---------- */
const stage = $('[data-crack-stage]');
const canBtn = $('[data-crack-can]');
const canImg = $('[data-crack-img]');
const nameLink = $('[data-crack-name]');
const status = $('[data-crack-status]');
const fizz = $('[data-fizz]', stage);
const angled = (f) => asset(`cans-plainsight/${f.id}-angled.webp?v=${ASSET_V}`);
let current = Math.max(0, FLAVORS.findIndex((f) => f.id === stage.dataset.flavor)); // the page opens on Shirley Temple
let busy = false;

function warm(i) { const img = new Image(); img.src = angled(FLAVORS[i % FLAVORS.length]); }
addEventListener('load', () => warm(current + 1), { once: true });

function bubbles() {
  const frag = document.createDocumentFragment();
  for (let i = 0; i < 26; i++) {
    const b = document.createElement('span');
    const s = 6 + Math.random() * 16;
    b.style.cssText = `left:${44 + Math.random() * 12}%;--s:${s}px;--x:${(Math.random() - 0.5) * 260}px;--d:${1.1 + Math.random() * 1.1}s;animation-delay:${Math.random() * 0.35}s`;
    frag.appendChild(b);
  }
  fizz.appendChild(frag);
  setTimeout(() => { fizz.innerHTML = ''; }, 2800);
}

function pour(next) {
  const f = FLAVORS[next];
  stage.classList.replace(`f-${FLAVORS[current].id}`, `f-${f.id}`);
  current = next;
  canImg.src = angled(f);
  nameLink.href = productUrl(f.id);
  nameLink.firstChild.textContent = `${f.name} `;
  status.textContent = `${f.name}. ${f.line}`;
  warm(next + 1);
}

canBtn.addEventListener('click', () => {
  if (busy) return;
  busy = true;
  bubbles();
  const next = (current + 1) % FLAVORS.length;
  if (reducedMotion) { pour(next); busy = false; return; }
  canBtn.classList.remove('is-cracked'); void canBtn.offsetWidth; canBtn.classList.add('is-cracked');
  setTimeout(() => {
    canBtn.classList.add('is-swap');
    setTimeout(() => {
      pour(next);
      const done = () => { canBtn.classList.remove('is-swap'); busy = false; };
      canImg.decode ? canImg.decode().then(done, done) : done();
    }, 320);
  }, 520);
});

/* ---------- "No more": strike each one through as it arrives ---------- */
const nopes = $('[data-nopes]');
if (reducedMotion || !('IntersectionObserver' in window)) nopes.classList.add('is-in');
else {
  const io = new IntersectionObserver(([e]) => {
    if (e.isIntersecting) { nopes.classList.add('is-in'); io.disconnect(); }
  }, { threshold: 0.6 });
  io.observe(nopes);
}
